import type { JSX, PropsWithChildren } from 'react'
import React from 'react'

import { useChatTheme } from '@oneToOne/shared/components/chat/theme/useChatTheme'

import { useTwindContext } from '@core/twind'

import { headerContainer } from './Header.twind'

export type HeaderProps = PropsWithChildren & {
  leftActions?: () => JSX.Element | null
  rightActions?: () => JSX.Element | null
  transparent?: boolean
}

/**
 * Header Component, has optional left and right actions
 */
export const Header: React.FC<HeaderProps> = ({
  leftActions,
  rightActions,
  children,
  transparent = false,
}) => {
  const { theme } = useChatTheme()
  const { tw } = useTwindContext()

  return (
    <div
      className={tw?.(
        headerContainer({ theme, transparent }),
        'absolute',
        'top-0',
        'left-0',
        'right-0',
        'flex',
        'justify-between',
        'items-center',
        'z-10',
      )}
    >
      <div
        className={tw?.(
          'flex',
          'grow',
          children ? 'w-1/3' : 'w-1/2',
          'justify-start',
        )}
      >
        {leftActions?.() ?? null}
      </div>
      {children ? (
        <div className={tw?.('flex', 'grow', 'w-1/3', 'justify-center')}>
          {children}
        </div>
      ) : null}
      <div
        className={tw?.(
          'flex',
          'grow',
          children ? 'w-1/3' : 'w-1/2',
          'justify-end',
        )}
      >
        {rightActions?.() ?? null}
      </div>
    </div>
  )
}
